//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum SocialNetwork {
  Bazaarvoice = 'Bazaarvoice',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Pinterest = 'Pinterest',
  Snapchat = 'Snapchat',
  TikTok = 'TikTok',
  Tumblr = 'Tumblr',
  Twitter = 'Twitter',
  Unknown = 'Unknown',
  YouTube = 'YouTube',
}

export const getSocialNetworkName = (network: SocialNetwork) => {
  switch (network) {
    case SocialNetwork.Bazaarvoice:
      return 'Bazaarvoice';
    case SocialNetwork.Facebook:
      return 'Facebook';
    case SocialNetwork.Instagram:
      return 'Instagram';
    case SocialNetwork.Pinterest:
      return 'Pinterest';
    case SocialNetwork.Snapchat:
      return 'Snapchat';
    case SocialNetwork.TikTok:
      return 'TikTok';
    case SocialNetwork.Tumblr:
      return 'Tumblr';
    case SocialNetwork.Twitter:
      return 'X';
    case SocialNetwork.YouTube:
      return 'YouTube';
    case SocialNetwork.Unknown:
      return 'Unknown';
  }
};

export const SocialNetworkColor: Record<SocialNetwork, string> = {
  [SocialNetwork.Bazaarvoice]: '#002E6E',
  [SocialNetwork.Facebook]: '#316FF6',
  [SocialNetwork.Instagram]: '#B900B4',
  [SocialNetwork.Pinterest]: '#FD7800',
  [SocialNetwork.Snapchat]: '#FFFC00',
  [SocialNetwork.TikTok]: '#00F2EA',
  [SocialNetwork.Tumblr]: '#36465D',
  [SocialNetwork.Twitter]: '#000000',
  [SocialNetwork.YouTube]: '#FF0000',
  [SocialNetwork.Unknown]: '#808080',
} as const;
